<template>
  <div
    class="rgb-box-wrapper"
    :class="{'align-canvas-top': alignTop}"
    :style="style"
    @click="$store.dispatch('selectRGBView', view.index)">
    <pixel-shaded-canvas
      :img="displayImgObject"
      :colorSettings="view"
      :canvasSize="rgbFit"
      :imgSize="rgbFit"
      :isFlipped="view.isFlipped"
      :style="{'border-color': borderColor, 'outline-color': borderColor}"
      class="rgb-image"/>
    <div class="rgb-title" :style="{top: titleTop, color: borderColor}">
      <img :src="src">
      {{view.title}}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pixelShadedCanvas from "../../canvas/components/PixelShadedCanvas";
export default {
  name: "rgbView",
  components: { pixelShadedCanvas },
  props: ["view", "rgbSize", "rgbFit"],
  computed: {
    ...mapGetters([ "displayImgObject" ]),
    titleTop() {
      if (this.alignTop || !this.rgbFit) return "7px";
      return "calc(100% - " + this.rgbFit.h + "px)";
    },
    borderColor() {
      return this.view && this.view.borderColor;
    },
    alignTop() {
      return this.view && this.view.alignTop;
    },
    style() {
      if (!this.rgbSize) return null;
      return { width: this.rgbSize.w + "px", height: this.rgbSize.h + "px" };
    },
    src() {
      return require("../../assets/" + this.view.icon);
    },
    usePixelCanvas() {
      return this.view.usePixelCanvas;
    }
  }
};
</script>

<style lang="scss" scoped>
.rgb-box-wrapper {
  position: relative;
  flex: 0 1 auto;

  .rgb-title {
    position: absolute;
    z-index: 5;
    left: 50%;
    transform: translateX(-50%);
    padding: 1px 7px;
    font-weight: bold;
    cursor: pointer;
    white-space: nowrap;

    img {
      max-width: 40px;
      max-height: 18px;
      min-height: 18px;
    }
  }

  .rgb-image {
    outline: 2px solid;
    border: 2px solid;
    top: calc(100% - 1px);
    transform: translate(-50%, -100%);
    cursor: pointer;
  }

  &.align-canvas-top {
    .rgb-image {
      top: 5px;
      transform: translateX(-50%);
    }
  }
}
</style>